import { Routes } from '@angular/router';
import { guestGuard } from './core/guards/guest-guard/guest-guard';
import { authGuard } from './core/guards/auth-guard/auth-guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'auth/login' },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./views/reset-password/reset-password').then((m) => m.ResetPassword),
  },
  {
    path: 'auth',
    loadComponent: () => import('./layouts/app-layout/app-layout').then((m) => m.AppLayout),
    canActivate: [guestGuard],
    children: [
      {
        path: 'login',
        loadComponent: () => import('./views/login/login').then((m) => m.Login),
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./views/forgot-password/forgot-password').then((m) => m.ForgotPassword),
      },
    ],
  },
  {
    path: 'home',
    loadComponent: () => import('./layouts/home-layout/home-layout').then((m) => m.HomeLayout),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./views/home/home').then((m) => m.Home),
      },
      {
        path: 'exchanges',
        loadComponent: () =>
          import('./views/home/exchanges/exchange-home/exchange-home').then(
            (m) => m.ExchangeHome,
          ),
      },
      {
        path: 'exchanges/mine',
        loadComponent: () =>
          import('./views/home/exchanges/exchange-mine/exchange-mine').then(
            (m) => m.ExchangeMine,
          ),
      },
      {
        path: 'exchanges/mine/:id',
        loadComponent: () =>
          import('./views/home/exchanges/exchange-mine-detail/exchange-mine-detail').then(
            (m) => m.ExchangeMineDetail,
          ),
      },
      {
        path: 'exchanges/mine/:id/property/:propertyId',
        loadComponent: () =>
          import(
            './views/home/exchanges/exchange-mine-detail-property/exchange-mine-detail-property'
          ).then((m) => m.ExchangeMineDetailProperty),
      },
      {
        path: 'exchanges/destination',
        loadComponent: () =>
          import('./views/home/exchanges/exchange-destination/exchange-destination').then(
            (m) => m.ExchangeDestination,
          ),
      },
      {
        path: 'exchanges/date',
        loadComponent: () =>
          import('./views/home/exchanges/exchange-date/exchange-date').then(
            (m) => m.ExchangeDate,
          ),
      },
      {
        path: 'exchanges/search',
        loadComponent: () =>
          import('./views/home/exchanges/exchange-search/exchange-search').then(
            (m) => m.ExchangeSearch,
          ),
      },
      {
        path: 'exchanges/results',
        loadComponent: () =>
          import('./views/home/exchanges/exchange-results/exchange-results').then(
            (m) => m.ExchangeResults,
          ),
      },
      {
        path: 'exchanges/detail/:propertyId',
        loadComponent: () =>
          import('./views/home/exchanges/exchange-detail/exchange-detail').then(
            (m) => m.ExchangeDetail,
          ),
      },
      {
        path: 'exchanges/detail/:propertyId/offer',
        loadComponent: () =>
          import(
            './views/home/exchanges/exchange-detail-propertys/exchange-detail-propertys'
          ).then((m) => m.ExchangeDetailPropertys),
      },
      {
        path: 'property/:id',
        loadComponent: () =>
          import('./views/home/property-detail/property-detail').then((m) => m.PropertyDetail),
      },
      {
        path: 'property/:id/weeks',
        loadComponent: () =>
          import('./views/home/client-property-weeks/client-property-weeks').then(
            (m) => m.ClientPropertyWeeks,
          ),
      },
      {
        path: 'property/:id/finanzas',
        loadComponent: () =>
          import('./views/home/finanzas/finanzas').then((m) => m.Finanzas),
      },
      {
        path: 'property/:id/expenses',
        loadComponent: () =>
          import('./views/home/expenses/expenses').then((m) => m.Expenses),
      },
    ],
  },
  { path: '**', redirectTo: 'auth/login' },
];
